// Yoonly NL overrides — only keys that differ from the regular NL translations.

import { getCgvLink, getDataRightsLink, getPrivacyPolicyLink } from "@/service/legalLinks/legalLinksService";
import { OptionsTranslations } from "./optionsTranslations.types";

const cgvUrl = getCgvLink();
// Missing keys automatically fall back to the standard 'fr' locale.
const dataRightsLink = getDataRightsLink("nl");
const privacyPolicyLink = getPrivacyPolicyLink("nl");

const optionsYoonlyNlTranslations: any = {
    optionsPage: {},
    "optin": {
        "terms": {
            "label": `Ik heb gelezen en accepteer de <a href='${cgvUrl}' target='_blank'><strong>Algemene Voorwaarden</strong></a>, de informatiedocumenten, de algemene en bijzondere verkoopvoorwaarden voor verzekeringen en het <a href='${privacyPolicyLink}' target='_blank'><strong>Beleid voor het beheer van persoonsgegevens</strong></a>.`,
            "short": "De verzamelde gegevens worden verwerkt door Yoonly, die verantwoordelijk is voor de verwerking en waarvan het hoofdkantoor is gevestigd op 19 rue Emmy Noether, 93400 Saint-Ouen, Frankrijk. <br/>",
            "full":
                `Deze gegevens zijn essentieel voor het beheren van uw reservering en het afsluiten van het bijbehorende contract. 
         Ze worden opgenomen in de database van Yoonly en tevens gebruikt om u informatie en advertenties te sturen over vergelijkbare producten en diensten, op basis van ons gerechtvaardigd belang en de wettelijke bepalingen met betrekking tot commerciële prospectie.
           U heeft rechten met betrekking tot uw gegevens, die u kunt uitoefenen via ons contactformulier <a href='${dataRightsLink}' target='_blank'>hier</a>. Voor meer informatie over de verwerking van uw gegevens, raadpleeg ons <a href='${privacyPolicyLink}' target='_blank'>beleid voor de bescherming van persoonsgegevens</a>.
         U kunt zich op elk moment afmelden via een link in de elektronische nieuwsbrieven of per e-mail.`
        }

    },
};

export default optionsYoonlyNlTranslations;
